document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  const intro =
    document.getElementById('tfv-vault-intro');

  const video =
    document.getElementById('tfv-vault-video');

  const skip =
    document.getElementById('tfv-vault-skip');

  const sound =
    document.getElementById('tfv-vault-sound');

  const stage =
    document.getElementById('tfv-vault-stage');

  const toast =
    document.getElementById('tfv-welcome-toast');

  if (!intro || !video || !skip) return;

  /*
   * Set this to true only while testing the intro.
   * Production must remain false.
   */
  const TEST_MODE = false;

  const STORAGE_KEY =
    'tfvVaultIntroLastVisitDate';

  function getLocalDateKey() {
    const now = new Date();

    const year =
      now.getFullYear();

    const month =
      String(
        now.getMonth() + 1
      ).padStart(2, '0');

    const day =
      String(
        now.getDate()
      ).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  function hasSeenIntroToday() {
    if (TEST_MODE) return false;

    try {
      return (
        window.localStorage.getItem(
          STORAGE_KEY
        ) === getLocalDateKey()
      );
    } catch (error) {
      console.warn(
        '[Fabric Vault] Intro storage unavailable:',
        error
      );

      return false;
    }
  }

  function markIntroSeenToday() {
    if (TEST_MODE) return;

    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        getLocalDateKey()
      );
    } catch (error) {
      console.warn(
        '[Fabric Vault] Unable to save intro visit:',
        error
      );
    }
  }

  /*
   * Remove the intro immediately when the customer
   * has already viewed it on this browser today.
   */
  if (hasSeenIntroToday()) {
  intro.remove();

  document.documentElement.classList.add(
    'tfv-intro-seen-today'
  );

  document.body.classList.add(
    'tfv-intro-finished'
  );

  return;
}

  /*
   * Record today as soon as the intro begins.
   * Navigating to products or collections will
   * therefore not trigger it again that day.
   */
  markIntroSeenToday();

  document.body.classList.add(
    'tfv-intro-lock'
  );

  function setStage(text) {
    if (stage) {
      stage.textContent = text;
    }
  }

  window.setTimeout(() => {
    setStage(
      'ESTABLISHING SECURE CONNECTION...'
    );
  }, 300);

  window.setTimeout(() => {
    setStage(
      'VERIFYING ACCESS...'
    );
  }, 1400);

  window.setTimeout(() => {
    setStage(
      'ACCESS LEVEL VERIFIED'
    );
  }, 2600);

  window.setTimeout(() => {
    setStage(
      'OPENING VAULT...'
    );
  }, 3800);

  window.setTimeout(() => {
    intro.classList.add(
      'tfv-clunk'
    );

    window.setTimeout(() => {
      intro.classList.remove(
        'tfv-clunk'
      );
    }, 300);
  }, 3650);

  if (sound) {
    sound.addEventListener(
      'click',
      function () {
        video.muted = false;
        video.volume = 1;

        video.play().catch((error) => {
          console.warn(
            '[Fabric Vault] Video playback failed:',
            error
          );
        });

        sound.textContent =
          'Sound On ✓';

        sound.classList.add(
          'tfv-sound-on'
        );

        window.setTimeout(() => {
          if (sound) {
            sound.remove();
          }
        }, 900);
      }
    );
  }

  function showToast() {
    if (!toast) return;

    toast.textContent =
      '✓ Welcome to The Fabric Vault';

    toast.classList.add(
      'tfv-show'
    );

    window.setTimeout(() => {
      toast.classList.remove(
        'tfv-show'
      );
    }, 3000);
  }

  function closeIntro() {
    if (
      intro.classList.contains(
        'tfv-hide'
      )
    ) {
      return;
    }

    intro.classList.add(
      'tfv-hide'
    );

    document.body.classList.remove(
      'tfv-intro-lock'
    );

    document.body.classList.add(
      'tfv-intro-finished'
    );

    window.setTimeout(() => {
      intro.remove();
      showToast();
    }, 900);
  }

  video.load();

  video.play().catch(() => {
    window.setTimeout(
      closeIntro,
      7000
    );
  });

  skip.addEventListener(
    'click',
    closeIntro
  );

  video.addEventListener(
    'ended',
    closeIntro
  );

  window.setTimeout(() => {
    closeIntro();
  }, 8500);
});